    import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
    import { OnlinePaymentTransaction } from '@app/core/business/invoice/online-payment-transaction';
    import { ETransactionQuestion } from '@app/core/business/invoice/etransaction-question';
    import { InvoiceService } from '@app/core/business/invoice/invoice.service';
    import { ContextService } from '@app/core/service/context.service';
    import { ToastrService } from 'ngx-toastr';
    import { environment } from '@env/environment';
    import { TranslateService } from '@ngx-translate/core';

    /**
     * https://blog.ng-book.com/the-ultimate-guide-to-forms-in-angular-2/
     */
    @Component({
    selector: 'app-online-payment-transaction-ca',
    templateUrl: './online-payment-transaction-ca.component.html',
    styleUrls: ['./online-payment-transaction-ca.component.scss']
    })
    export class OnlinePaymentTransactionCAComponent implements OnInit {

    @Input()
    transaction: OnlinePaymentTransaction;

    @Output()
    endTransaction = new EventEmitter<string>();

    @Output()
    resetSelectedDocuments = new EventEmitter();
    /**
     * Référence du formulaire pour basculer sur le site qui gère le paiement par carte
     */
    @ViewChild('billPaymentForm')
    billPaymentForm: any;

    /**
     * Permet de stocker l'objet retourné par le backend qui permettra de valoriser
     * le formulaire pour les transaction CA
     */
    public eTransactionQuestion: ETransactionQuestion;

    /**
     * Permet de ne gérer qu'un seul bouton pour prendre en compte la demande qui
     * va interroger le backend.
     */
    public backendCallButton: boolean = true;

    constructor(
        private invoiceService: InvoiceService,
        private contextService: ContextService,
        private toastrService: ToastrService,
        private translate: TranslateService
    ) { }

    ngOnInit() {
        //if (!environment.production) { console.debug("Starting OnlinePaymentTransactionComponent.ngOnInit"); }

        // Initialisation
        this.eTransactionQuestion = new ETransactionQuestion();
        this.resetTransaction();

        // Chargement des informations de paiement
        /** fait au niveau du parent maintenant /// let companyCode = this.contextService.context.companyCode;
        this.invoiceService.getOnlinePaymentInfosHtmlRaw(companyCode).subscribe(
        htmlRaw => {
            this.onlinePaymentInfosHtmlRaw = htmlRaw;
        }
        ); */

        //if (!environment.production) { console.debug("Ending OnlinePaymentTransactionComponent.ngOnInit"); }
    }

    /**
     * Permet de réinitialiser les données une fois que les données sont envoyées
     * en cas d'erreur, on pourrait se retrouver avec des données qui ne
     * correspondent plus à ce que l'utilisateur souhaite faire
     */
    resetTransaction() {
        this.transaction.value = 0;
        this.transaction.relatedDocuments = [];
        this.transaction.originalDocuments = [];
        this.backendCallButton=true;
        this.resetSelectedDocuments.next();
    }

    /**
     * Permet de déclancher la soumission du formulaire avec les éléments valorisées
     * du backend et de se rendre sur l'application de paiement en ligne
     */
    gotoOnlinePaymentWebapp() {
        //if (!environment.production) { console.debug("Starting : OnlinePaymentTransaction.gotoOnlinePaymentWebapp"); }

        // Soumission du formulaire
        this.billPaymentForm.nativeElement.submit();

        // Retrait de la transaction
        this.resetTransaction();

        // Repasser sur le bouton qui appelle le backoffice
        this.backendCallButton = false;

        this.endTransaction.next("theEnd");

        //if (!environment.production) { console.debug("Ending : OnlinePaymentTransaction.gotoOnlinePaymentWebapp"); }
    }

    cancelPayment() {

        // Retrait de la transaction
        this.resetTransaction();

        // Go to "My customer"
        //this.router.navigateByUrl('/dashboard/customer');
    }

    /**
     * Permet de vérifier que la transaction peut être validée
     */
    isValid(): boolean {
        let result: boolean = false;
        if (this.transaction.value > 0) {
        result = true;
        }
        return result;
    }
    /**
     * Permet d'envoyer les informations au backoffice puis de valoriser et
     * valider le formulaire pour que l'utilisateur accède à l'interface du site
     * de paiement en ligne
     * Ressources : https://www.devglan.com/angular/payumoney-integration-angular
     * @param form le formulaire
     * @param e l'événement qui déclenche l'action et la référence de son déclencheur
     */
    validateTransaction() {

        if (!environment.production) { console.debug("Starting : OnlinePaymentTransaction.validateTransaction"); }

        if (this.isValid()) {

            // Vérification que chaque transaction est unique et qu'aucun duplicats n'est présent
            this.transaction.relatedDocuments = this.transaction.relatedDocuments.filter((value, index, self) => { 
                return self.indexOf(value) === index;
            });

            this.transaction.originalDocuments = this.transaction.originalDocuments.filter((value, index, self) => { 
                return self.indexOf(value) === index;
            });

            // Envoi des élements pour valider la transaction auprès du backoffice
            this.invoiceService.validateTransactionCA(this.contextService.context.companyCode, this.contextService.context.customerCode, 
                                                      this.transaction.value, this.transaction.relatedDocuments, this.transaction.originalDocuments)
            .subscribe(
                success => {
                    // Le backend a retourné l'objet
                    this.eTransactionQuestion = success;

                    // Vérification de la consistence
                    if (this.eTransactionQuestion
                        && this.eTransactionQuestion.pbX_SITE.length > 0 
                        && this.eTransactionQuestion.pbX_RANG.length > 0
                        && this.eTransactionQuestion.pbX_IDENTIFIANT.length > 0
                        && this.eTransactionQuestion.pbX_TOTAL.length > 0)
                        {

                        this.resetTransaction();


                        // Bascule sur le bouton qui permet de se rendre sur l'application de paiement en ligne
                        this.backendCallButton = false;

                        // Mise en place d'un délai pour soumettre le formulaire et la redirection
                        // Cela permet au framework de valoriser le formulaire
                        setTimeout(() => { this.gotoOnlinePaymentWebapp(); }, 2000);

                        // éviter que la demande ne puisse être prise en compte 2 fois ; fait grâce au bouton qui est mis en disable une fois le click effectué

                        // Message permettant d'indiquer que la demande a été prise en compte
                        let redirectMessage = this.translate.instant('online-payment.redirectMessage');

                        this.toastrService.success(redirectMessage);

                        //if (!environment.production) { console.debug("Ending : OnlinePaymentTransaction.validateTransaction"); }
                    } else {
                        //if (!environment.production) { console.debug("L'objet retourné ne contient pas les éléments nécessaires au démarrage de la transaction avec le service de paiement en ligne."); }
                    }
                },
                error => {
                    // Une erreur est arrivée du côté du backoffice

                    // Affichage de l'erreur à l'utilisateur
                    //this.toastrService.error(error);

                    this.resetTransaction();

                    if (!environment.production) { console.debug("Ending : OnlinePaymentTransaction.validateTransaction"); }
                }
            );
        } 
        else {
            if (!environment.production) { console.debug("OnlinePaymentTransaction.validateTransaction : Impossible de valider la transaction car le montant n'est pas supérieur à 0"); }
        }

        // Dans tous les cas, on vide la transaction pour ne pas avoir de données
        // qui ne seraient pas prises en compte
        this.resetTransaction();
        
        //if (!environment.production) { console.debug("Ending : OnlinePaymentTransaction.validateTransaction"); }
    }

    /**
     * Permet d'afficher/masquer les informations sur le paiement en ligne
     */
    togglePayInformation() {
        this.invoiceService.togglePayInformation();
    }
}
